import mixins from 'vue-typed-mixins'
import { mixin as clickaway } from 'vue-clickaway'

import Utilities from '~mixins/utilities'

import scrollToFirstInvalidField from '~utils/scroll-to-first-invalid-field'

export default mixins(Utilities).extend({
  mixins: [clickaway],
  data() {
    return {
      desiredAmount: '',
      numberOfVouchers: '1',
      showTooltip: false,
      desiredAmountError: '',
      numberOfVouchersError: '',
      desiredAmountMin: 10,
      desiredAmountMax: 1000,
      numberOfVouchersMin: 1,
      numberOfVouchersMax: 20,
      hasSubmitted: false,
      selectedCurrency: '',
      currencyError: '',
    }
  },
  created() {
    this.selectedCurrency = this.defaultCurrency
  },
  computed: {
    isLoading() {
      return this.$store.getters['sales/loading']
    },
    activeItem() {
      return this.$store.getters['sales/activeItem']
    },
    voucherNumberOptions() {
      return Array.from({ length: this.numberOfVouchersMax }, (_, i) => ({
        value: (i + 1).toString(),
        label: (i + 1).toString(),
      }))
    },
  },
  watch: {
    desiredAmount() {
      if (this.hasSubmitted) {
        this.validate()
      }
    },
    selectedCurrency() {
      if (this.hasSubmitted) {
        this.validate()
      }
    },
  },
  methods: {
    validate() {
      const desiredAmountValidationResult = this.validateNumber(this.desiredAmount, 'desiredAmount', this.desiredAmountMin, this.desiredAmountMax)
      this.desiredAmountError = desiredAmountValidationResult.error

      const numberOfVouchersValidationResult = this.validateNumber(this.numberOfVouchers, 'numberOfVouchers', this.numberOfVouchersMin, this.numberOfVouchersMax)
      this.numberOfVouchersError = numberOfVouchersValidationResult.error

      const currencyValidationResult = this.validateCurrency()
      this.currencyError = currencyValidationResult.error

      return (
        desiredAmountValidationResult.success
        && numberOfVouchersValidationResult.success
        && currencyValidationResult.success
      )
    },
    validateCurrency() {
      if (!this.selectedCurrency) {
        return {
          error: this.tr('pages.sales.buy.currency.error.not_selected'),
          success: false,
        }
      }

      if (!this.currencyOptions.map((option) => option.code).includes(this.selectedCurrency)) {
        return {
          error: this.tr('pages.sales.buy.currency.error.invalid'),
          success: false,
        }
      }

      return {
        error: '',
        success: true,
      }
    },
    validateNumber(amount, name, min, max) {
      if (!amount || Number.isNaN(amount)) {
        return {
          error: this.tr(`pages.sales.buy.${name}.error.not_selected`),
          success: false,
        }
      }

      if (!Number.isInteger(parseFloat(amount)) || Number.isNaN(Number(amount))) {
        return {
          error: this.tr(`pages.sales.buy.${name}.error.not_integer`),
          success: false,
        }
      }

      if (Number(amount) < min || Number(amount) > max) {
        return {
          error: this.tr(`pages.sales.buy.${name}.error.out_of_range`, { min, max }),
          success: false,
        }
      }

      return {
        error: '',
        success: true,
      }
    },
    async onContinue() {
      this.hasSubmitted = true
      if (this.validate()) {
        await this.$store.dispatch('sales/setDesiredAmountInCents', Number(this.desiredAmount) * 100)
        await this.$store.dispatch('sales/setNumberOfVouchers', Number(this.numberOfVouchers))
        await this.$store.dispatch('sales/setVoucherDenominationCurrency', this.selectedCurrency)

        await this.$store.dispatch('sales/resetErrors')
        await this.$router.push(
          this.$i18nTo(
            {
              name: 'voucherSaleCheckout',
            },
          ),
        )
      } else {
        scrollToFirstInvalidField()
      }
    },
  },
})
